import { render, staticRenderFns } from "./Scene10.vue?vue&type=template&id=06565a0f&scoped=true"
import script from "./Scene10.vue?vue&type=script&lang=js"
export * from "./Scene10.vue?vue&type=script&lang=js"
import style0 from "./Scene10.vue?vue&type=style&index=0&id=06565a0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06565a0f",
  null
  
)

export default component.exports